import type { MyBetPart } from '@ps/isp-web-services-types';
import React from 'react';

import { getHandicapSelectionValue } from '@swf/sports/utils/getHandicapSelectionValue';

interface Props {
  part: MyBetPart;
}

const SelectionName: React.FC<Props> = ({ part }) => {
  const handicap = getHandicapSelectionValue({
    handicap: part.handicap,
    runnerResultType: undefined
  });

  return (
    <>
      {part.selectionName} {handicap ? `(${handicap}) ` : ''}
    </>
  );
};

export default SelectionName;
